// src/gatsby-browser.js
import "@fontsource/darker-grotesque/500.css"; 
import "./src/styles/global.css"

import { navigate } from 'gatsby';

export const onClientEntry = () => {
  const langRedirectedKey = 'emmagumbert_session_lang_redirected';

  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const { pathname } = window.location;

    // 1. Redireccionar /ca/* a /* per corregir URLs antigues indexades
    // Aquesta redirecció és per a URLs que erròniament puguin tenir el prefix /ca/
    if (pathname.startsWith('/ca/')) {
      const newPath = pathname.substring(3); // Elimina el prefix '/ca'
      // Si el resultat és un string buit (era '/ca/'), redirigeix a l'arrel '/'
      navigate(newPath === '' ? '/' : newPath, { replace: true });
      return; // Important: Surt després de redirigir per evitar lògica conflictiva
    }

    // 2. Lògica de redirecció basada en l'idioma del navegador (a /es/ si s'escau)
    // Comprova si ja hem fet una redirecció basada en l'idioma en aquesta sessió
    if (sessionStorage.getItem(langRedirectedKey)) {
      return;
    }

    const browserLang = navigator.language || navigator.userLanguage;
    const browserLangCode = browserLang ? browserLang.slice(0, 2) : 'ca'; // Per defecte 'ca'

    // L'idioma per defecte és 'ca' (servit a l'arrel, p.ex. /contacte).
    // La versió en espanyol està sota '/es/' (p.ex. /es/contacto).

    const isSpanishBrowser = browserLangCode === 'es';
    const isOnSpanishPage = pathname.startsWith('/es/'); // Comprova si ja estem a una pàgina /es/
    const isOnDefaultLanguagePage = !isOnSpanishPage; // Estem a la pàgina d'idioma per defecte (català) si no és /es/

    if (isSpanishBrowser && isOnDefaultLanguagePage) {
      // Si estem a l'arrel ('/'), el nou camí serà '/es'.
      // Si estem a '/pagina', el nou camí serà '/es/pagina'.
      const targetPathForSpanish = pathname === '/' ? '' : pathname;
      const newPath = `/es${targetPathForSpanish}`;
      
      sessionStorage.setItem(langRedirectedKey, 'true');
      navigate(newPath, { replace: true }); // replace: true per no afegir a l'historial
    }
  }
};
